export default __webpack_public_path__ + "static/char-35-4750c668d4076c49d3444f9344dec8d4.webp";